import { footerColumns } from '@/mocks/homeData';

export default function SiteFooter() {
  return (
    <footer className="bg-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1fr] lg:gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                <i className="ri-flashlight-fill text-lg leading-none"></i>
              </span>
              <span className="font-heading text-base font-bold text-foreground-950">网爆黑料</span>
            </div>
            <p className="mt-4 max-w-sm text-[13px] leading-6 text-foreground-600">
              网爆黑料证据链深扒专区，围绕网爆黑料资金往来、网爆黑料合同文件与网爆黑料内部邮件做公开资料整理，用时间脉络与关系图谱帮你理清事件，看清真相。
            </p>
            <span className="mt-4 inline-flex items-center gap-2 rounded-full border border-secondary-200 bg-secondary-50 px-3 py-1.5 font-label text-xs text-secondary-800">
              <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-secondary-500"></span>
              线索持续梳理中
            </span>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-950">
                <a href="#top" className="cursor-pointer transition-colors hover:text-accent-600">
                  {column.title}
                </a>
              </h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="cursor-pointer text-[13px] text-foreground-600 transition-colors hover:text-foreground-950"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-foreground-500">
            © 2026 网爆黑料 · 内容为公开资料整理演示，请理性看待
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#method" className="cursor-pointer font-label text-xs text-foreground-600 hover:text-foreground-950">
              免责声明
            </a>
            <a href="#method" className="cursor-pointer font-label text-xs text-foreground-600 hover:text-foreground-950">
              内容说明
            </a>
            <a href="#discussion" className="cursor-pointer font-label text-xs text-foreground-600 hover:text-foreground-950">
              联系处理
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}